'use client';

import type { ReactNode } from 'react';
import { SidebarAccountMenu } from './SidebarAccountMenu';
import { SidebarNav } from './SidebarNav';
import { SidebarUpgrade } from './SidebarUpgrade';

export function SidebarContents({
  rail = false,
  mobile = false,
  onNavigate,
  header,
}: {
  rail?: boolean;
  mobile?: boolean;
  onNavigate?: () => void;
  header: ReactNode;
}) {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="shrink-0">{header}</div>
      <div className="min-h-0 grow overflow-y-auto overscroll-contain px-2 py-3 [scrollbar-width:thin]">
        <SidebarNav rail={rail} mobile={mobile} onNavigate={onNavigate} />
      </div>
      <div className="shrink-0 border-t border-[var(--fd-line)] p-2">
        <SidebarUpgrade rail={rail} onNavigate={onNavigate} />
        <SidebarAccountMenu
          rail={rail}
          mobile={mobile}
          onNavigate={onNavigate}
        />
      </div>
    </div>
  );
}
